import { DefaultInput, DefaultFormAutocomplete } from './index'
import StateResource from '../state'
import EntitiesResource from '../entities'

export default {
    entity_id: new DefaultFormAutocomplete('Job/Show', EntitiesResource, 'entity_id'),
    name: new DefaultInput('Location Name*'),
    description: new DefaultInput('Description'),
    address1: new DefaultInput('Address Line 1'),
    address2: new DefaultInput('Address Line 2'),
    city: new DefaultInput('City*'),
    state_id: new DefaultFormAutocomplete('State*', StateResource, 'state_id'),
    postal: new DefaultInput('Postal'),
    country_id: new DefaultInput('Country'),
    phone: new DefaultInput('Phone'),
    minwage_override_city: new DefaultInput('MW City Override'),
    minwage_override_postal: new DefaultInput('MW Postal Override'),
    status: new DefaultInput('Enabled'),
    default: new DefaultInput('Default'),
}
